/* eslint-disable no-unused-vars */
import './Legal.css'

function Legal() {
    return (
        <div className="legal-page">
            <div className="legal-content">
                <h1>Privacy Policy & Terms of Use</h1>
                <p className="legal-updated">Last updated: May 2026</p>

                <div className="legal-section">
                    <h2>Privacy Policy</h2>

                    <h3>Information We Collect</h3>
                    <p>
                        When you create an account, we collect your email address and password.
                        When you use the platform, we collect information about which brands you
                        save, dislike, and interact with. This data is used to power the
                        recommendation engine.
                    </p>

                    <h3>Data & Related</h3>
                    <p>
                        Your data is stored using Supabase.
                    </p>
                </div>

                <div className="legal-section">
                    <h2>Terms of Use</h2>

                    <h3>Service Description</h3>
                    <p>
                        Marque Index is a brand discovery platform that provides 
                        menswear brand recommendations based on user preferences.
                    </p>

                    <h3>User Accounts</h3>
                    <p>
                        You are responsible for maintaining the security of your account. You must
                        provide accurate information when creating an account.
                    </p>

                    <h3>Intellectual Property</h3>
                    <p>
                        All brand names, logos, and product images displayed on this platform are
                        trademarks and property of their respective owners.
                    </p>

                    <h3>Disclaimer</h3>
                    <p>
                        Brand recommendations are based on our scoring system and
                        represent editorial opinions. We make no guarantees about the accuracy
                        of recommendations or the quality of any listed brand's products.
                    </p>

                    <h3>Limitation of Liability</h3>
                    <p>
                        Marque Index is provided "as is" without warranties of any kind. We are
                        not liable for any damages arising from your use of the platform or your
                        interactions with any listed brand.
                    </p>

                    <h3>Changes</h3>
                    <p>
                        We may update these terms and privacy policy from time to time. Continued
                        use of the platform after changes constitutes acceptance of the updated terms.
                    </p>
                </div>

                <div className="legal-section">
                    <h2>Contact</h2>
                    <p>
                        For questions about privacy or these terms, contact us at{' '}
                        <a href="mailto:hello@marqueindex.com">hello@marqueindex.com</a>.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Legal
